import { bindEvents, offset } from '../helpers';

import AnimationController from './animation';
import ImageController from './image';


class RevealController {

	constructor() {
		this.selector = '';
		this.imageSelector = '';

		this.position = false;
		this.reveals = [];
		this.hidden = [];

		this.threshold = 0;

		this.animation = null;

		this.customEvents = {
			reveal: new CustomEvent('reveal')
		};

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	collectAll(scope = document) {
		this.position = false;
		this.reveals = [];
		const reveals = scope.querySelectorAll(this.selector);
		for (const el of reveals) {
			this.reveals.push({
				el,
				img: el.querySelector(this.imageSelector),
				offset: 0,
				revealed: false
			});
		}
		this.measure();
	}

	measure() {
		this.threshold = window.innerHeight * 0.75;
		for (const r of this.reveals) r.offset = offset.top(r.el);
	}

	collectHidden(position) {
		const hidden = [];
		for (let i = 0, l = this.reveals.length; i < l; ++i) {
			if (!this.reveals[i].revealed && position.current + this.threshold > this.reveals[i].offset) {
				hidden.push(i);
			}
		}
		return hidden;
	}

	update(position) {
		this.hidden = [];
		if (position.current !== this.position) {
			const hidden = this.collectHidden(position);
			if (hidden.length) {
				this.position = position.current;
				this.hidden = hidden;
				return true;
			}
		}
	}

	render() {
		for (const i of this.hidden) {
			this.reveals[i].revealed = true;

			this.reveals[i].el.classList.add('is-revealed');
			this.reveals[i].el.dispatchEvent(this.customEvents.reveal);

			if (this.reveals[i].img) {
				setTimeout(() => ImageController.swap(this.reveals[i].img), 250);
			}
		}
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		}, 'reveal');
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	_onWindowLoad() {
		this.measure();
	}

	_onWindowResize() {
		this.measure();
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);
	}

}

export default new RevealController();
